import { InjectionToken } from '@angular/core';

export const API_ENV = new InjectionToken<IrisEnv>('Set api environment');
